import Modal from 'utils/packages/Modal';
const ConnectionUsedInAutosaveModal = {
    show: (navigateToAutosave, type) => {
        Modal.showConfirmation({
            title: 'This connection is used to Autosave',
            subtitle: `To ${type} this connection, you first need to choose a different bank connection for your Emma Autosave.`,
            confirmButtonTitle: 'Okay',
            cancelButtonTitle: 'Manage Autosave',
            onConfirm: Modal.hide,
            onPressCancel: navigateToAutosave,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
export default ConnectionUsedInAutosaveModal;
